/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './radiology-study.reducer';

export const RadiologyStudyDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const radiologyStudyEntity = useAppSelector(state => state.radiologyStudy.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="radiologyStudyDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.radiologyStudy.detail.title">RadiologyStudy</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.radiologyStudy.id">Id</Translate>
            </span>
          </dt>
          <dd>{radiologyStudyEntity.id}</dd>
          <dt>
            <span id="instructions">
              <Translate contentKey="tinyMedicRestApp.radiologyStudy.instructions">Instructions</Translate>
            </span>
          </dt>
          <dd>{radiologyStudyEntity.instructions}</dd>
          <dt>
            <span id="dateActivated">
              <Translate contentKey="tinyMedicRestApp.radiologyStudy.dateActivated">Date Activated</Translate>
            </span>
          </dt>
          <dd>{radiologyStudyEntity.dateActivated}</dd>
          <dt>
            <span id="autoExpireDate">
              <Translate contentKey="tinyMedicRestApp.radiologyStudy.autoExpireDate">Auto Expire Date</Translate>
            </span>
          </dt>
          <dd>{radiologyStudyEntity.autoExpireDate}</dd>
          <dt>
            <span id="dateStopped">
              <Translate contentKey="tinyMedicRestApp.radiologyStudy.dateStopped">Date Stopped</Translate>
            </span>
          </dt>
          <dd>{radiologyStudyEntity.dateStopped}</dd>
          <dt>
            <span id="reason">
              <Translate contentKey="tinyMedicRestApp.radiologyStudy.reason">Reason</Translate>
            </span>
          </dt>
          <dd>{radiologyStudyEntity.reason}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.radiologyStudy.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{radiologyStudyEntity.microSec}</dd>
          <dt>
            <span id="voided">
              <Translate contentKey="tinyMedicRestApp.radiologyStudy.voided">Voided</Translate>
            </span>
          </dt>
          <dd>{radiologyStudyEntity.voided ? 'true' : 'false'}</dd>
          <dt>
            <span id="voidedBy">
              <Translate contentKey="tinyMedicRestApp.radiologyStudy.voidedBy">Voided By</Translate>
            </span>
          </dt>
          <dd>{radiologyStudyEntity.voidedBy}</dd>
          <dt>
            <span id="dateVoided">
              <Translate contentKey="tinyMedicRestApp.radiologyStudy.dateVoided">Date Voided</Translate>
            </span>
          </dt>
          <dd>{radiologyStudyEntity.dateVoided}</dd>
          <dt>
            <span id="voidReason">
              <Translate contentKey="tinyMedicRestApp.radiologyStudy.voidReason">Void Reason</Translate>
            </span>
          </dt>
          <dd>{radiologyStudyEntity.voidReason}</dd>
          <dt>
            <span id="urgency">
              <Translate contentKey="tinyMedicRestApp.radiologyStudy.urgency">Urgency</Translate>
            </span>
          </dt>
          <dd>{radiologyStudyEntity.urgency}</dd>
          <dt>
            <span id="orderStatus">
              <Translate contentKey="tinyMedicRestApp.radiologyStudy.orderStatus">Order Status</Translate>
            </span>
          </dt>
          <dd>{radiologyStudyEntity.orderStatus}</dd>
          <dt>
            <span id="scheduledDate">
              <Translate contentKey="tinyMedicRestApp.radiologyStudy.scheduledDate">Scheduled Date</Translate>
            </span>
          </dt>
          <dd>{radiologyStudyEntity.scheduledDate}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.radiologyStudy.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{radiologyStudyEntity.timestampentry}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.radiologyStudy.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{radiologyStudyEntity.lastupdated}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.radiologyStudy.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{radiologyStudyEntity.cursor}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.radiologyStudy.active">Active</Translate>
            </span>
          </dt>
          <dd>{radiologyStudyEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="otc">
              <Translate contentKey="tinyMedicRestApp.radiologyStudy.otc">Otc</Translate>
            </span>
          </dt>
          <dd>{radiologyStudyEntity.otc ? 'true' : 'false'}</dd>
          <dt>
            <span id="patientType">
              <Translate contentKey="tinyMedicRestApp.radiologyStudy.patientType">Patient Type</Translate>
            </span>
          </dt>
          <dd>{radiologyStudyEntity.patientType}</dd>
          <dt>
            <span id="exposed">
              <Translate contentKey="tinyMedicRestApp.radiologyStudy.exposed">Exposed</Translate>
            </span>
          </dt>
          <dd>{radiologyStudyEntity.exposed ? 'true' : 'false'}</dd>
          <dt>
            <span id="addedByType">
              <Translate contentKey="tinyMedicRestApp.radiologyStudy.addedByType">Added By Type</Translate>
            </span>
          </dt>
          <dd>{radiologyStudyEntity.addedByType}</dd>
          <dt>
            <span id="addedByID">
              <Translate contentKey="tinyMedicRestApp.radiologyStudy.addedByID">Added By ID</Translate>
            </span>
          </dt>
          <dd>{radiologyStudyEntity.addedByID}</dd>
          <dt>
            <span id="modifiedByType">
              <Translate contentKey="tinyMedicRestApp.radiologyStudy.modifiedByType">Modified By Type</Translate>
            </span>
          </dt>
          <dd>{radiologyStudyEntity.modifiedByType}</dd>
          <dt>
            <span id="modifiedByID">
              <Translate contentKey="tinyMedicRestApp.radiologyStudy.modifiedByID">Modified By ID</Translate>
            </span>
          </dt>
          <dd>{radiologyStudyEntity.modifiedByID}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.radiologyStudy.servedBy">Served By</Translate>
          </dt>
          <dd>{radiologyStudyEntity.servedBy ? radiologyStudyEntity.servedBy.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.radiologyStudy.appointment">Appointment</Translate>
          </dt>
          <dd>{radiologyStudyEntity.appointment ? radiologyStudyEntity.appointment.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.radiologyStudy.otcBy">Otc By</Translate>
          </dt>
          <dd>{radiologyStudyEntity.otcBy ? radiologyStudyEntity.otcBy.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.radiologyStudy.patient">Patient</Translate>
          </dt>
          <dd>{radiologyStudyEntity.patient ? radiologyStudyEntity.patient.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.radiologyStudy.orderedBy">Ordered By</Translate>
          </dt>
          <dd>{radiologyStudyEntity.orderedBy ? radiologyStudyEntity.orderedBy.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.radiologyStudy.imageTests">Image Tests</Translate>
          </dt>
          <dd>{radiologyStudyEntity.imageTests ? radiologyStudyEntity.imageTests.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.radiologyStudy.prescription">Prescription</Translate>
          </dt>
          <dd>{radiologyStudyEntity.prescription ? radiologyStudyEntity.prescription.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.radiologyStudy.labPrescription">Lab Prescription</Translate>
          </dt>
          <dd>{radiologyStudyEntity.labPrescription ? radiologyStudyEntity.labPrescription.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.radiologyStudy.treatmentPlan">Treatment Plan</Translate>
          </dt>
          <dd>{radiologyStudyEntity.treatmentPlan ? radiologyStudyEntity.treatmentPlan.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.radiologyStudy.procedure">Procedure</Translate>
          </dt>
          <dd>{radiologyStudyEntity.procedure ? radiologyStudyEntity.procedure.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/radiology-study" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/radiology-study/${radiologyStudyEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default RadiologyStudyDetail;
